import { render } from "./groupbtnAdmin.vue?vue&type=template&id=0bdf4fa0&scoped=true"
import script from "./groupbtnAdmin.vue?vue&type=script&lang=js"
export * from "./groupbtnAdmin.vue?vue&type=script&lang=js"

import "./groupbtnAdmin.vue?vue&type=style&index=0&id=0bdf4fa0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdf4fa0"]])

export default __exports__